import {
  CloseCircleOutlined,
  PlusOutlined
} from "@ant-design/icons";
  
  import classPopup from "@src/models/control/popup";
import {
  Button,
  Input,
  Modal
} from "antd";
import React, { useState } from "react";
import {
  COMMON_CONSTANT,
  KEY,
  lang
} from "../../constants/common.const";
import { showMessage } from "../../constants/utils";
import BoxSearchMachineVideo from "./boxSearchMachineVideo";
// import "./index.scss";
  
export function SearchMachineVideo({
    onSubmit,
    setShowLoading,
    value,
    clicksaved,
    listOffice,
    listSelectMachine,
    ...props
  }) {
    const [popupMachine, setPopupMachine] = useState({
      ...new classPopup(),
      list: [],
    });
  
    const [checkedList, setCheckedList] = useState([]);
  
    const onAddMachine = () => {
      if (checkedList.length > 0) {
        onSubmit(checkedList[0]);
        setCheckedList([]);
        setPopupMachine({ ...popupMachine, show: false });
      } else {
        showMessage(KEY.WARMING, "機械を選択してください");
      }
    };
  
    return (
      <>
        <Input.Search
          disabled={props.disabled}
          style={props.style}
          value={value}
          onChange={props.onChange}
          onSearch={() => setPopupMachine({ ...popupMachine, show: true })}
          className={`${props.className} input-search-machine-video`}
        />
        <Modal
          className="box-search-machine"
          centered
          title={"機器名を追加"}
          visible={popupMachine.show}
          onCancel={() => {
            setPopupMachine({ ...popupMachine, show: false });
          }}
          footer={[
            <Button
              key={2}
              onClick={() => {
                setPopupMachine({ ...popupMachine, show: false });
              }}
            >
              <CloseCircleOutlined />
              {lang.CANCEL}
            </Button>,
            <Button
              key={1}
              className="buttonPC button--info"
              onClick={onAddMachine}
            >
              <PlusOutlined />
              {COMMON_CONSTANT.ADD}
            </Button>,
          ]}
        >
          <BoxSearchMachineVideo
            setLoading={setShowLoading}
            listFilter={popupMachine.list}
            checkedList={[checkedList, setCheckedList]}
            isOneValue={true}
            defaultValue={value}
            listOffice={listOffice}
            listSelectMachine={listSelectMachine}
          />
        </Modal>
      </>
    );
  }